export function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

function isTzMobileNational(nineDigits) {
  return nineDigits.length === 9 && /^[67]\d{8}$/.test(nineDigits);
}

export function normalizeTzPhone(input) {
  if (input == null) return null;
  const raw = String(input).trim();
  if (!raw) return null;

  let digits = digitsOnly(raw);
  if (digits.startsWith('00')) digits = digits.slice(2);

  if (digits.length === 10 && digits.startsWith('0')) {
    digits = digits.slice(1);
  }

  if (isTzMobileNational(digits)) {
    digits = `255${digits}`;
  }

  if (
    digits.length === 12 &&
    digits.startsWith('255') &&
    isTzMobileNational(digits.slice(3))
  ) {
    return `+${digits}`;
  }
  return null;
}

export function formatTzPhoneDisplay(input) {
  const e164 = normalizeTzPhone(input);
  if (!e164) return String(input || '').trim();
  const national = e164.slice(4);
  return `+255 ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
}

export function isValidTzPhone(input) {
  return normalizeTzPhone(input) != null;
}

/** Any international E.164 (or local TZ 06/07). Prefer normalizeTzPhone for payment. */
export function normalizeIntlPhone(input) {
  const tz = normalizeTzPhone(input);
  if (tz) return tz;
  if (input == null) return null;
  const raw = String(input).trim();
  if (!raw) return null;

  let digits = digitsOnly(raw);
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.length >= 8 && digits.length <= 15) {
    return `+${digits}`;
  }
  return null;
}

export function isValidIntlPhone(input) {
  return normalizeIntlPhone(input) != null;
}

/**
 * Soft hint from TCRA numbering (July 2026). Not payment authority —
 * SafariYetu method tokens + customer choice decide the push.
 * 074–076 Vodacom M-Pesa; 077/065/067 Yas/Tigo; 078/068/069 Airtel; 062 Halo.
 */
export function detectTzMobileNetwork(input) {
  const e164 = normalizeTzPhone(input);
  if (!e164) return null;
  const prefix = e164.slice(4, 6);
  if (['73', '74', '75', '76'].includes(prefix)) return 'mpesa';
  if (['65', '67', '71', '77'].includes(prefix)) return 'tigopesa';
  if (['68', '69', '78', '79'].includes(prefix)) return 'airtel';
  if (['61', '62'].includes(prefix)) return 'halopesa';
  return null;
}

export function tzNetworkLabel(networkId) {
  switch (networkId) {
    case 'tigopesa':
      return 'Tigo Pesa';
    case 'halopesa':
      return 'HaloPesa';
    case 'airtel':
      return 'Airtel Money';
    case 'mpesa':
      return 'M-Pesa';
    default:
      return '';
  }
}
